import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import apifunctions from '../../components/Tienda/api/functions.js';

import './profesionales.scss';

import { InputLabeled, InputComponent, AlertMensaje } from './Inputs';

import { apiprofesionales } from './Profesionales'

const GoToProfesionalesForm = ({ history }) => (
    <section>
        <div className="container">
            <div className="row">
                <div className="col-sm-8 offset-sm-2">
                    <div className="text-center mt-5">
                        <h3>¿Desea aparecer en esta sección?</h3>
                        <button
                            type="button"
                            onClick={() => history.push("/profesionales/form")}
                            className="btn btn-lg btn-primary mt-5"
                        >
                            Envíenos su solicitud{" "}
                            <i className="fa fa-envelope-o" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

const ProfesionalDetail = (props) => {
    return props.nombre && (
        <address className="border rounded p-2">
            <h4>{props.nombre.toUpperCase()}</h4>
            {
                props.email &&
                <a target="_blank" className="d-block m-2" href={`mailto:${props.email}?Subject=Hola,%20me%20interesa%20consultar%20sobre%20`}><i class="fa fa-envelope-o" aria-hidden="true"></i> {props.email.toLowerCase()}</a>
            }
            <p className="m-2">
            {
                props.telefono &&
                <a target="_blank" className="" href={`tel: ${props.telefono}`}><i class="fa fa-phone" aria-hidden="true"></i> {props.telefono}</a>
            }
            {
                props.telefono_2 &&
                <a target="_blank" className="ml-5" href={`tel: ${props.telefono_2}`}><i class="fa fa-phone" aria-hidden="true"></i> {props.telefono_2}</a>
            }
            {
                props.telefono_3 &&
                <a target="_blank" className="ml-5" href={`tel: ${props.telefono_3}`}><i class="fa fa-phone" aria-hidden="true"></i> {props.telefono_3}</a>
            }
            </p>
            {
                props.ciudad && props.provincia &&
                <p className="text-capitalize m-2">
                    {
                        props.direccion && `${props.direccion.toLowerCase()} - `
                    }
                    {`${props.ciudad.toLowerCase()} - ${props.provincia.toLowerCase()}`}
                </p>
            }
        </address>
    )
}


const ProfesionalesList = (props) => {

    const [categoriaId, setCategoriaId] = useState(null);
    const [profesionales, setProfesionales] = useState([]);

    const { categorias } = props;

    const history = useHistory();

    const updateProfesionales = () => {



        let parameters = {
            pageSize: 99,
            sort: ["nombre"],
            filters: ["categoria=" + categoriaId]
        }

        apifunctions.get(
            apiprofesionales.profesionales,
            null,
            null,
            parameters,
            data => {
                if (data && data.data && data.data.length >= 0) {
                    setProfesionales(data.data)
                }
            },
            () => setProfesionales([]),
            () => setProfesionales([])
        );
    };

    useEffect(() => {
        if (categoriaId && categoriaId > 0) {
            updateProfesionales();
        } else {
            setProfesionales([])
        }
    }, [categoriaId]);

    return (
        <>
            <section>
                <div className="container ">
                    <div className="row">
                        <div className="col-sm-8 offset-sm-2">
                            <div className="text-center mb-3">
                                <h3>Buscar por Categoría</h3>
                            </div>
                            <InputComponent
                                component={
                                    <select name="categoria_id"
                                        className="form-control "
                                        onChange={(evt) => setCategoriaId(evt.target.value)}
                                    >
                                        <option value="-1">Seleccione una categoría</option>
                                        {
                                            categorias.map(c =>
                                                <option value={c.id}>{c.nombre.toUpperCase()}</option>
                                            )
                                        }
                                    </select>
                                }
                            />
                            {
                                categoriaId == null ? (
                                    <h4 className="text-center pt-5">No hay resultados para mostrar. Debe elegir una Categoría.</h4>
                                ) : (
                                    profesionales && profesionales.length > 0 ? (
                                        profesionales.map(p => <ProfesionalDetail {...p} />)
                                    ) : (
                                        <h4 className="text-center pt-5">No hay resultados para mostrar.</h4>
                                    )
                                )
                            }
                        </div>
                    </div>
                </div>
            </section>
            <GoToProfesionalesForm history={history} />
        </>
    );
}

export default ProfesionalesList;
